<template>
  <div id="whats-app-bottom" class="whats-app-bottom">
    <a :href="whatsapplink" target="_blank">
      <img
        src="/images/whatsapp1.png"
        class="img-flip-on-rtl whats-app"
        alt=""
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'WhatsApp',
  props: {
    whatsapplink: String,
  },
}
</script>

<style lang="scss" scoped>
.whats-app {
  max-width: 60px;
}
.body-rtl {
  .img-flip-on-rtl {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
  .whats-app-bottom {
    right: $px20;
    left: unset !important;
  }
}
.whats-app-bottom {
  display: block;
  position: fixed;
  left: 0.75rem;
  bottom: 8.7rem;
  z-index: 3;
}
@media (max-width: 575px) {
  .whats-app-bottom {
    display: block;
  }
}
</style>
